import axios, { AxiosRequestConfig } from 'axios';

let env = process.env.REACT_APP_ENV;

const baseURL = env || window.API_BASE_URL ;


const apiToken = process.env.REACT_APP_FULL_ACCESS_TOKEN;


axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;


axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = false;

class request {
  static getBaseURL() {
    return baseURL;
  }
  static async get(url = '', params: AxiosRequestConfig['params'] = {}, headers: AxiosRequestConfig['headers'] = {}, responseType: AxiosRequestConfig['responseType'] = 'json') {
    try {
      return await axios.get(url, { params, headers, responseType });
    } catch (error) {
      console.error('Error in GET request:', error);
      throw error;
    }
  }

  static async post(url = '', body = {}, params: AxiosRequestConfig['params'] = {}, headers: AxiosRequestConfig['headers'] = {}, responseType: AxiosRequestConfig['responseType'] = 'json') {
    try {
      return await axios.post(url, body, { params, headers, responseType });
    } catch (error) {
      console.error('Error in POST request:', error);
      throw error;
    }
  }

  static async put(url = '', body = {}, headers: AxiosRequestConfig['headers'] = {}) {
    try {
      return await axios.put(url, body, { headers });
    } catch (error) {
      console.error('Error in PUT request:', error);
      throw error;
    }
  }

  static async patch(url = '', body = {}, headers: AxiosRequestConfig['headers'] = {}) {
    try {
      if (Object.keys(body).length !== 0) {
        const params = this.setParams({ params: body });
        url += `?${params}`;
      }
      return await axios.patch(url, body, { headers });
    } catch (error) {
      console.error('Error in PATCH request:', error);
      throw error;
    }
  }

  static async delete(url = '', data = {}, headers: AxiosRequestConfig['headers'] = {}) {
    try {
      return await axios.delete(url, { data, headers });
    } catch (error) {
      console.error('Error in DELETE request:', error);
      throw error;
    }
  }

  static setParams({ params = {} }: { params: Record<string, any> }) {
    return Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
  }
}

export default request;
